import React from "react";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import contactImg from '../../assets/images/contact.jpg'

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-5 justify-center">
      <img
        className="w-full h-64 object-contain rounded-lg mb-2"
        data-aos="zoom-in"
        src={contactImg}
        alt="contactImg"
      />

      <div className="flex flex-col gap-1">
        <h3 className="text-3xl font-bold text-white" data-aos="zoom-in">
          Md Shojib Hossain
        </h3>

        <p className="text-lg font-normal text-gray-400" data-aos="zoom-in">
          Junior Software Engineer
        </p>

        <p className="text-base text-gray-400 tracking-wide" data-aos="zoom-in">
          I am Md Shojib Hossain, a Junior Software Engineer passionate about building dynamic and user-friendly web applications. I am eager to learn and make an impact in a collaborative environment.
        </p>

        <p
          className="text-base text-gray-400 flex items-center gap-2"
          data-aos="zoom-in"
        >
          Phone: <span className="text-lightText">+8801790407979</span>
        </p>
        <p
          className="text-base text-gray-400 flex items-center gap-2"
          data-aos="zoom-in"
        >
          Email:{" "}
          <span className="text-lightText" data-aos="zoom-in">
            mdshojib922@gmail.com
          </span>
        </p>
        <p
          className="text-base text-gray-400 flex items-center gap-2"
          data-aos="zoom-in"
        >
          Github:{" "}
          <span className="text-lightText">https://github.com/its-shojib</span>
        </p>
      </div>

      <div className="flex flex-col gap-0" data-aos="zoom-in">
        <h2 className="text-base uppercase font-titleFont mb-4 text-center">Find me on</h2>
        <div className="flex justify-center items-center gap-4">
          <span className="bannerIcon">
            <a
              href="https://wa.me/8801790407979"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
          </span>
          <span className="bannerIcon">
            <a href="mailto:mdshojib922@gmail.com">
              <SiGmail />
            </a>
          </span>
          <span className="bannerIcon">
            <a
              href="https://linkedin.com/in/md-shojib-hossain"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
